import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiInput = (_param)=>{
    var { biData , innerRef , stopPropagation  } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef  } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("input", _extends({}, props, {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiInput.displayName = 'BiInput';
export default BiInput;
